import { useWorklog } from "../../Hooks/Features/ProjectGlance/useWorklog"
import CommonGrid from "../CommonCompo/CommonGrid/CommonGrid";
import { SkeletonContainer, SkeletonDataTable } from "../Loader/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog } from "primereact/dialog";

const WorklogDetails = ({ projectId, showPopup, dateFilter, onClose }) => {

    const key = "issue_type_summary";
    const { filterValues, setFilterValues, getWorklogDetails, showDetails, worklogDetails, setWorklogDetails, loader, columns } = useWorklog({ projectId, key, showPopup, dateFilter });

    return (
        <Dialog visible={showPopup?.visible} onHide={() => onClose()} draggable={false} header={`Worklog Details - ${showPopup?.group?.issue_type_group_name}`} className='modal-large' style={{ height: "65vh" }} blockScroll>
            <div className="d-flex h-100">
                <div className="w30 h-100">
                    <div className="fs-6 fw-semibold mb-3 text-black">
                        Project Breakdown
                    </div>
                    {loader?.issue_type_summary ? <div style={{ height: "90%" }}><SkeletonContainer /></div> : <div className="d-flex flex-column overflow-y-auto overflow-x-hidden pe-2" style={{ height: "90%" }}>
                        {showDetails?.issue_type_data?.map(item => (
                            <div key={item?.issue_type_id} className="d-flex align-items-center c-pointer justify-content-between p-2 rounded " onClick={() => { getWorklogDetails(item); setWorklogDetails((prev) => ({ ...prev, visible: true, issue_type: item })) }} style={{ backgroundColor: item?.issue_type_name === worklogDetails?.issue_type?.issue_type_name ? "#f5f5f5" : "transparent" }}>
                                <div className="text-truncate">{item?.issue_type_name}</div>
                                <div className="d-flex align-items-center gap-2 w50 fw-semibold text-black">
                                    <div className='text-center border rounded-pill px-2 w50'>{item?.log_hours_percentage ? parseFloat(item?.log_hours_percentage?.toFixed(2)) : 0}%</div>
                                    <div className='w50 text-right text-decoration-underline'>{item?.time_spent ? item?.time_spent : "0h"}</div>
                                </div>
                            </div>
                        ))}
                    </div>}
                </div>
                <div className="border-start ps-2 h-100 w70">
                    <div className="d-flex justify-content-between align-items-center mb-2 ">
                        <div className="fs-6 fw-semibold text-black">
                            Timesheet Details {worklogDetails?.issue_type?.issue_type_name ? "- " + worklogDetails?.issue_type?.issue_type_name : ""}
                        </div>
                        <div className="d-flex gap-1 align-items-center">
                            <button className='sk-btn-primary' title={filterValues?.expand ? 'Collapse All' : 'Expand All'} onClick={() => setFilterValues((prev) => ({...prev, expand: !filterValues?.expand}))}><FontAwesomeIcon icon={`fa-solid fa-${filterValues?.expand ? "compress" : "expand"}`} /></button>
                            <button className='sk-btn-primary' title='Refresh' onClick={() => getWorklogDetails(null)}><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
                        </div>
                    </div>
                    {worklogDetails?.visible ?
                        loader?.details ? <SkeletonDataTable numSkeletons={10} /> :
                            <div className="overflow-y-auto w100" style={{ height: "90%" }}>
                                <CommonGrid columns={columns} data={[{ id: "all", title: "", children: worklogDetails?.row_data }]} strippedTable={true} rowHeight={"auto"} />
                            </div>
                        : <></>
                    }
                </div>
            </div>
        </Dialog>
    )
}

export default WorklogDetails